module.exports = __webpack_public_path__ + "static/media/lys-is-wrong.1bf330ad.mp3";